import createCustomAxios from '../utils/axios';
const http = createCustomAxios();
const httpDataBase = createCustomAxios(
	'https://data.drcnet.com.cn/statistical',
);
const httpExpert = createCustomAxios('https://expert.drcnet.com.cn/expert');
// 导航接口
export function getNav(params) {
	return http({
		method: 'get',
		url: '/WebChannelCommonController/getMenuList',
		params,
	});
}
// 文章接口1
export function getDocList(params) {
	return http({
		method: 'get',
		url: '/indexController/getIndexDocs',
		params,
	});
}
// 文章接口2
export function getDocsByUids(params) {
	return http({
		method: 'get',
		url: '/DocCommonController/getDocsByUids',
		params,
	});
}
// 文章接口2
export function getDocListByUid(params) {
	return http({
		method: 'get',
		url: '/CommonController/common/getDocListByUid',
		params,
	});
}
//首页文章列表
export function getHomeList(params) {
	return http({
		method: 'get',
		url: '/DocCommonController/getDocsByUids',
		params,
	});
}
//报告页列表
export function docByWebChannel(params) {
	return http({
		method: 'get',
		url: '/CommonController/common/docByWebChannel',
		params,
	});
}
// 报告库过滤接口（titleFilter 排除关键字 + keyWords 包含关键字）
// 用绝对 URL 覆盖默认 baseURL，因为该接口走 www.drcnet.com.cn 子域
export function docByTitleAndKeyWords(params) {
	return http({
		method: 'get',
		url: 'https://www.drcnet.com.cn/reportapi/CommonController/common/docByTitleAndKeyWords',
		params,
	});
}
//获取下方专题
export function getAllSonMenus(params) {
	return http({
		method: 'get',
		url: '/WebChannelCommonController/getAllSonMenus',
		params,
	});
}

export function getReportDocsByUids(params) {
	return http({
		method: 'get',
		url: '/DocCommonController/getDocsByUids',
		params,
	});
}
//热点专题
export function getIndexHotTopicDocs(params) {
	return http({
		method: 'get',
		url: '/DocCommonController/getIndexHotTopicDocs',
		params,
	});
}
//国研网数据统计库
export function tables2(params) {
	return httpDataBase({
		method: 'get',
		url: '/homepage/tables2',
		params,
	});
}
//专家库-关系
export function relation(params) {
	return httpExpert({
		method: 'get',
		url: '/api/aggregation/expert/relation',
		params,
	});
}
//专家库-词云
export function nameList(params) {
	return httpExpert({
		method: 'get',
		url: '/api/aggregation/keyword/nameList',
		params,
	});
}
